import { MprcRequestErrorDialog, MprcRequestIndicator } from "components";
import { MprcRequestSnackbarErrorReport } from "components/MprcRequestErrorReport";
import { ManageEnrollOperation, TrainingType, UserInfoDto } from "generated/CoreApi_v1";
import moment from "moment";
import { useCoreApi } from "providers/CoreApiProvider";
import React, { useEffect, useState } from "react";
import { BatchEditSelectedUsers } from "views/foundation/user/components/BatchEdit/BatchEditSelectedUsers";
import { EditEnrollmentStepProps, OPERATION_PAGE_SIZE } from "views/lms/enrollment/Home";
import { EnrollmentExtraTimeOptions, useEnrollmentManagementContext } from "views/lms/enrollment/Home/EnrollmentManagementWrapper";
import { useEnrollmentOperationContext } from "views/lms/enrollment/Home/Operation/OperationBox";

////////////////////////////////////////////////////////////////////////////

export const OperationSelectedUsers: React.FC<EditEnrollmentStepProps> = (props) => {

    const { setCanSave } = props;
    const { loadingSelected, setLoadingSelected, setPosting, selectedUsers, setSelectedUsers } = useEnrollmentOperationContext();

    const api = useCoreApi();
    const ctx = useEnrollmentManagementContext();
    const training = ctx.training!;
    const classroom = ctx.classroom;

    const [viewError, setViewError] = useState<any>();
    const [pageNumber, setPageNumber] = useState<number>(1);
    const [loading, setLoading] = useState<boolean>(true);

    ///
    const handleDelete = (item: UserInfoDto) => {
        setPosting(true);
        api.v1.enrollmentOperation.removeUserEnroll({
            trainingId: training.trainingId,
            operation: ctx.operation!,
            userIds: [item.userId]
        }).then(result => {
            if (result.data) setLoading(true);
        }).catch(e => {
            MprcRequestSnackbarErrorReport(e);
        }).finally(() => setPosting(false));
    };

    ///
    const clearAll = () => {
        setPosting(true);
        api.v1.enrollmentOperation.clearUsersEnroll({
            trainingId: training.trainingId,
            operation: ctx.operation!,
        }).then(result => {
            if (result.data) setLoading(true);
        }).catch(e => {
            MprcRequestSnackbarErrorReport(e);
        }).finally(() => setPosting(false));
    };

    ////////////////////////////////////////////////////////////////////////////
    /// EFFECT'S
    ////////////////////////////////////////////////////////////////////////////

    useEffect(() => {
        async function getData() {
            try {
                const result = await api.v1.enrollmentOperation.getManagedEnrollmentSelectedUsers({
                    trainingId: training.trainingId,
                    operation: ctx.operation!,
                    pageNumber,
                    pageSize: OPERATION_PAGE_SIZE
                });
                setSelectedUsers(result.data);
            } catch (e) {
                setSelectedUsers(undefined);
                setViewError(e);
            } finally {
                setLoadingSelected(false);
                setLoading(false);
            }
        }

        if (loading) getData();
    }, [loading]);

    useEffect(() => {
        if (loadingSelected) {
            setPageNumber(1);
            setLoading(true);
        }
    }, [loadingSelected]);

    useEffect(() => {
        ctx.setTraining({ ...training, totalSelected: selectedUsers?.totalRows ?? 0 });
    }, [selectedUsers]);

    useEffect(() => {
        var isValid = (ctx.operation != ManageEnrollOperation.Enrollment || ctx.training?.trainingType == TrainingType.LearningPath || classroom != undefined) && selectedUsers != undefined && selectedUsers.items.length > 0;

        switch (ctx.operation) {
            case ManageEnrollOperation.Cancel:
                isValid = isValid && ctx.options.cancelReason.length > 0;
                break;
            case ManageEnrollOperation.AllowExtraTime:
                isValid = isValid && (
                    (ctx.options.extraTimeOption == EnrollmentExtraTimeOptions.Days && ctx.options.aditionalDays > 0)
                    ||
                    (ctx.options.extraTimeOption == EnrollmentExtraTimeOptions.Date && ctx.options.untilDate != null && moment(ctx.options.untilDate).isValid())
                );
                break;
            case ManageEnrollOperation.Revoke:
                isValid = isValid && (ctx.options.revokeReason.length > 0);
                break;
            case ManageEnrollOperation.UndoRevoke:
                isValid = isValid && (ctx.options.undoRevokeReason.length > 0);
                break;
            case ManageEnrollOperation.Exclude:
                isValid = isValid && ctx.options.excludeReason.length > 0;
                break;
            case ManageEnrollOperation.ReEnrollForRecycling:
                isValid = (ctx.operation != ManageEnrollOperation.ReEnrollForRecycling || ctx.training?.trainingType == TrainingType.LearningPath || classroom != undefined) && selectedUsers != undefined && selectedUsers.items.length > 0;
                break;
        }

        setCanSave(isValid);

    }, [classroom, ctx.options, selectedUsers, ctx.operation]);

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <>
            <MprcRequestErrorDialog error={viewError} onClose={() => setViewError(null)} />
            <MprcRequestIndicator visible={loading} type={"request"} />

            <BatchEditSelectedUsers
                onClearAll={clearAll}
                onDeleteUser={handleDelete}
                viewData={selectedUsers}
                onChangePage={page => {
                    setPageNumber(page);
                    setLoading(true);
                }}
                onReload={() => {
                    setPageNumber(1);
                    setLoading(true);
                }}
            />
        </>
    );
};
